module.exports = __webpack_public_path__ + "static/img/zhengmian@3x.8f9890a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhengmian@3x.png
// module id = k0DN
// module chunks = 1